import { useMemo } from 'react';
import { PageType, TemplateType } from '@pkgs/components/types/tracking';
import { DEFAULT_OPTIONS } from '@pkgs/api/utils/filters';
import { getLastBreadcrumbString } from '@pkgs/api';

import { getPriceDetailsBySettings } from '@/utils/getPriceDetailsBySettings';
import { PageVariant } from '@/types/expose';
import { useExposePageProps } from '@/hooks/useExposePageProps';

import { useSettings } from './useSettings';
import { useGAEventOnce } from './useGAEvent';
import { useListing } from './queries/useListing';

export const useExposeGAEventOnce = () => {
  const pageProps = useExposePageProps();
  const {
    data: { listing, genericListing },
  } = useListing();
  const { pageVariant } = pageProps;
  const { language } = useSettings();
  let smallestBreadcrumb: string | undefined = undefined;
  if (listing) {
    smallestBreadcrumb = getLastBreadcrumbString(listing);
  }

  const price = useMemo(() => {
    if (!listing) return undefined;

    const { priceJsonLdFormattedValue, hasPriceOnRequest } = getPriceDetailsBySettings(
      listing,
      listing.basePrice ?? {},
      language,
      listing.baseCurrency ?? DEFAULT_OPTIONS.currency,
    );

    return hasPriceOnRequest ? undefined : priceJsonLdFormattedValue;
  }, [language, listing]);

  useGAEventOnce('pageView', {
    templateType: TemplateType.EXPOSE,
    pageType: pageVariant === PageVariant.DEVELOPMENT_PROJECT ? PageType.DEVELOPMENT_EXPOSE : PageType.EXPOSE,
    ...(listing?.masterDataShopId && {
      masterDataShopId: listing.masterDataShopId,
    }),
    property_id: genericListing.displayId,
    property_type: genericListing.propertyType,
    ...(price && { property_price: price }),
    ...(genericListing.baseCurrency && { currency: genericListing.baseCurrency }),
    ...(smallestBreadcrumb && { city: smallestBreadcrumb }),
    ...(genericListing.countryAlpha2 && { country: genericListing.countryAlpha2 }),
  });
};
